<template>
  <v-footer v-if="showFooter" class="gray darken-2 d-flex body-2" dark>
    <v-container>
      <v-row>
        <v-col v-if="formParams.clientName" md="6" sm="12">
          <h3>{{ formParams.clientName }}</h3>
        </v-col>
        <v-col v-if="showAddress" md="2" sm="12">
          <h4>{{ t("NOTRE_ADRESSE") }}</h4>
          <div>{{ formParams.adr1 }}</div>
          <div>{{ formParams.adr2 }}</div>
          <div>{{ formParams.adr3 }}</div>
        </v-col>
        <v-col v-if="showContact" md="2" sm="12">
          <h4>{{ t("NOUS_CONTACTER") }}</h4>
          <div v-if="formParams.phone">
            <v-icon small class="mr-2"> mdi-phone </v-icon>
            {{ formParams.phone }}
          </div>
          <div>
            <link-with-icon v-show="!!formParams.email" :is-mailto="true" :url="formParams.email" :label="formParams.email" icon="mdi-email" />
          </div>
        </v-col>
        <v-col v-if="showSocialNetworks" md="2" sm="12">
          <h4>{{ t("RESEAUX_SOCIAUX") }}</h4>

          <IconLink v-show="formParams.website" :url="formParams.website" :label="t('SITE_WEB')" icon="mdi-web" />

          <IconLink v-show="!!formParams.facebook" :url="formParams.facebook" icon="mdi-facebook" label="Facebook" />

          <IconLink v-show="!!formParams.twitter" :url="formParams.twitter" label="Twitter" icon="mdi-twitter" />

          <IconLink v-show="!!formParams.linkedin" :url="formParams.linkedin" label="Linkedin" icon="mdi-linkedin" />
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
import LinkWithIcon from "@/components/LinkWithIcon.vue"
import IconLink from "@/components/IconLink"
import { mapGetters } from "vuex"

export default {
  components: {
    LinkWithIcon,
    IconLink
  },
  computed: {
    ...mapGetters(["formParams", "t"]),
    showSocialNetworks() {
      return (
        this.formParams.showSocialNetworksInFooter &&
        (this.formParams.website || this.formParams.facebook || this.formParams.twitter || this.formParams.linkedin)
      )
    },
    showContact() {
      return this.formParams.email || this.formParams.phone
    },
    showAddress() {
      return this.formParams.adr1 || this.formParams.adr2 || this.formParams.adr3
    },
    showFooter() {
      return this.formParams.showFooter && (this.showSocialNetworks || this.showContact || this.showAddress || this.formParams.clientName)
    }
  }
}
</script>

<style>
</style>